@let currentMoment = currentMoment$ | async;
@let longestElapsedTime = longestElapsedTime$ | async;
@let count = parkedCount$ | async;
<div class="parked-footer-bar">
  <div class="footer-content">
    <div class="footer-title">{{ TranslationKeys.AssistantParkedFooterTasksCount | translate: { count: count } }}</div>
    <div class="footer-subtitle">
      {{ TranslationKeys.AssistantParkedFooterLongestElapsedTime | translate }}
      {{ longestElapsedTime | dateDifference: currentMoment | durationFormat: 'time-in-state' }}
    </div>
  </div>
  <app-footer-actions [mode]="TaskActionsMode.Parked"></app-footer-actions>
</div>
